import classes from "./MetricsTable.module.css"
import type React from "react";

interface MetricsTableProps {
    title: string;
    headers: string[];
    data: string[][];
    table_width?: string;
}

export default function MetricsTable({title, headers, data, table_width} : MetricsTableProps) {
    const gridStyle = {
        gridTemplateColumns: `repeat(${headers.length}, 1fr)`
    };
    const tableWidth = {
        width: `${table_width ? table_width : "100%"}`,
    }
    return (
        <div className={classes.metricsContainer} style={tableWidth}>
            <div className={classes.tableContainer}>
                <h2 className={classes.metricsTitle}>
                    {title}
                </h2>
                <div className={classes.tableGrid} style={gridStyle}>
                    {headers.map((header, k) => (
                        <div key={k} className={`${classes.tableHeader} ${k === 0 ? classes.justifyStartCell : ""}`}>
                            {header}
                        </div>
                    ))}
                    {data.map((row, i) => (
                        <>
                            {row.map((cell, j) => (
                                <div key={j} className={`${classes.tableCell} ${j === 0 ? classes.justifyStartCell : ""}`}>
                                    {cell}
                                </div>
                            ))}
                        </>
                    ))}
                </div>
            </div>
        </div>
    )
}